import Image from "next/image";
import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem } from "../carousel";

import Flex from "../Flex";
import { cn } from "@/shared/libs/commonUtils";
import Typography from "../Typography";
import type { CarouselApi } from "@/types/components/carousel";

export default function ImageGallerySlider({
  images,
  options,
  className,
  deviceType,
}: {
  images: string[];
  options?: Partial<unknown>;
  className?: string;
  deviceType: DeviceType;
}) {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);

    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);

  return (
    <Carousel
      setApi={setApi}
      className={cn("relative", className)}
      opts={options}
      dir="ltr"
    >
      <Flex className="absolute backdrop-blur-sm z-10 left-0 top-0 gap-x-1 translate-x-4 translate-y-4 text-background/30 rounded-full py-2 px-3 justify-center items-center">
        <Typography
          variant="body3"
          className="font-normal text-xs text-background"
        >
          {count}
        </Typography>
        <Typography
          variant="body3"
          className="font-normal text-xs text-background"
        >
          از
        </Typography>
        <Typography
          variant="body3"
          className="font-normal text-xs text-background"
        >
          {current}
        </Typography>
      </Flex>

      <CarouselContent className="w-full max-md:h-auto mx-auto">
        {images.map((img, index) => (
          <CarouselItem
            className="w-full px-1 cursor-pointer shadow-1"
            key={`image-${index}`}
          >
            <Image
              src={img}
              width={500}
              height={500}
              className="w-full h-full rounded-xs object-cover object-center transition ease-in-out duration-200"
              alt="image-gallery"
            />
          </CarouselItem>
        ))}
      </CarouselContent>
      {/* <Flex>
        {scrollSnaps.map((_, index) => (
          <ImageGallerySliderDots
            className={"w-5 h-5 border-2 border-foreground"}
            onClick={() => onDotButtonClick(index)}
          />
        ))}
      </Flex> */}
    </Carousel>
  );
}
